module.exports = __webpack_public_path__ + "img/pos2_txt.ee43c6f5.png";